import React from 'react';

type PageShellWidth = 'full' | 'wide' | 'md' | 'narrow';

interface PageShellProps {
  children: React.ReactNode;
  /** Content max width. Default wide (7xl) matches Discover/Garage. */
  width?: PageShellWidth;
  /** Extra classes on the outer page canvas */
  className?: string;
  /** Extra classes on the content container */
  contentClassName?: string;
  /** When true, adds bottom padding for sticky mobile toolbars */
  withToolbar?: boolean;
}

const widthClass: Record<PageShellWidth, string> = {
  full: 'w-full px-4 sm:px-6 lg:px-8 py-8 flex-1',
  wide: 'page-content',
  md: 'max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8 flex-1 w-full',
  narrow: 'page-content-narrow',
};

/**
 * Standard destination page chrome: gray-950 canvas + consistent gutters.
 * Prefer this over re-copying min-h-screen / max-w-* recipes.
 */
export const PageShell: React.FC<PageShellProps> = ({
  children,
  width = 'wide',
  className = '',
  contentClassName = '',
  withToolbar = false,
}) => (
  <div className={`page duo-canvas ${withToolbar ? 'page-with-toolbar' : ''} ${className}`.trim()}>
    <div className={`${widthClass[width]} ${contentClassName}`.trim()}>{children}</div>
  </div>
);

export default PageShell;
